import produce from "immer"
import { CcApprovalLevel } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcApprovalLevel: CcApprovalLevel = {
    id: null,
    name: "",
    accountId: null,
    projectId: null,
    groupId: null,
    groupAccountId: null,
    groupProjectId: null,
    module: null,
    creator: null,
    order: 0,
}

const initCcApprovalLevelState: types.CcApprovalLevelState = {
    moduleLevelList: {},

    levelList: {},
    levelEdit: initCcApprovalLevel,

    reloadList: true,
    reloadEdit: true,
}

const ccApprovalLevelReducer = produce((
    draft: types.CcApprovalLevelState = initCcApprovalLevelState,
    action: ActionTypes = null,
): types.CcApprovalLevelState => {
    switch (action.type) {
        case types.CC_MODULE_APPROVAL_LEVEL_LIST:
            draft.moduleLevelList = { ...draft.moduleLevelList, ...action.moduleLevelList }
            return draft

        case types.CC_APPROVAL_LEVEL_LIST:
            draft.levelList = { ...draft.levelList, ...action.levelList }
            return draft

        case types.CC_APPROVAL_LEVEL_EDIT:
            draft.levelEdit = action.level
            return draft

        case types.CC_APPROVAL_LEVEL_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_APPROVAL_LEVEL_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccApprovalLevelReducer
